import * as React from 'react';
import { SVGProps } from 'react';

const SvgTriangleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m18 9-6 6-6-6" stroke="#797979" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default SvgTriangleIcon;
